import styled from "@emotion/styled"
import { Snackbar } from "@material-ui/core"
import SnackbarContent, { SnackbarContentProps } from "@material-ui/core/SnackbarContent"
import Typography, { TypographyProps } from "@material-ui/core/Typography"
import { docketTheme } from "theme"

type SCProps = {
  state: string
} & SnackbarContentProps

type TypoProps = {
  state: string
} & TypographyProps

const { white } = docketTheme.colors

const variantColors: any = {
  error: {
    background: docketTheme.colors.error.normal,
    color: white,
  },
  info: {
    background: docketTheme.colors.info,
    color: white,
  },
  success: {
    background: docketTheme.colors.success,
    color: white,
  },
}

const IconButtonWrapper: any = {
  display: "flex",
  justifyContent: "center",
  width: "5rem",
}

export const StyledSnackbar = styled(Snackbar)`
  top: 7rem;
`

export const StyledSnackbarContent = styled(SnackbarContent)<SCProps>`
  background-color: ${props => (props.state ? variantColors[props.state].background : docketTheme.colors.grey[80])};
  padding: 0;
  width: 80vw;
  max-width: 110rem;
  height: 5.5rem;
  box-shadow: none;
  align-items: center;
`
export const MessageContainer = styled.div`
  margin: -0.8rem 0;
  display: flex;
  align-items: center;
`
export const MessageSpan = styled.span`
  max-width: 73.6rem;
  font-size: 1.6rem;
`

export const MessageIcon = styled.span`
  width: ${IconButtonWrapper.width};
  display: ${IconButtonWrapper.display};
  justify-content: ${IconButtonWrapper.justifyContent};
  margin-left: 2rem;
  margin-right: 2rem;
  .SnackbarIcon {
    width: 5.5rem;
    height: 5.5rem;
    color: ${white};
  }
`

export const StyledTypography = styled(Typography)<TypoProps>`
  color: ${props => (props.state ? variantColors[props.state].color : white)};
  font-size: 1.6rem;
  font-weight: bold;
  line-height: normal;
`

export const ActionContainer = styled.div`
  margin-right: 2rem;
  padding: 0.5rem 0;
  width: ${IconButtonWrapper.width};
  display: ${IconButtonWrapper.display};
  justify-content: ${IconButtonWrapper.justifyContent};
`
